// Web-only stand-in for @react-native/assets-registry (not shipped with RN 0.87).
// react-native-svg imports it to resolve require()'d image assets, which this app doesn't use on web.
const assets = [];
export function registerAsset(asset) {
  return assets.push(asset);
}
export function getAssetByID(id) {
  return assets[id - 1];
}
